module.exports = __webpack_public_path__ + "static/img/suv-yellow.3ad5030.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/suv-yellow.svg
// module id = ueje
// module chunks = 74